export const GoogleTagEvents = {
    PAGE: 'page'
  } as const;